import { apiClient } from '@/features/common/infrastructure/apiClient';

import type { TikTokVerifyResult } from './types';

export async function verifyTikTokConnection(): Promise<TikTokVerifyResult> {
  const { data } = await apiClient<TikTokVerifyResult>('/api/auth/tiktok/verify');
  return data;
}

export async function refreshTikTokVideos(): Promise<void> {
  await apiClient('/api/auth/tiktok/refresh-videos', {
    method: 'POST',
  });
}
